import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_OL_CONDOMINIO } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIDolCondominioState extends EntityState<IID_OL_CONDOMINIO, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_CONDOMINIO })
export class IIDolCondominioStore extends EntityStore<IIDolCondominioState> {
  constructor() {
    super([]);
  }
}
